export const GLOBAL_CATALOG_RESET_STATE = 'GLOBAL_CATALOG_RESET_STATE';
export const GLOBAL_CATALOG_CURRENT_ITEM = 'GLOBAL_CATALOG_CURRENT_ITEM';

export const GLOBAL_CATALOG_REQUEST_LOADING = 'GLOBAL_CATALOG_REQUEST_LOADING';
export const GLOBAL_CATALOG_REQUEST_SUCCESS = 'GLOBAL_CATALOG_REQUEST_SUCCESS';
export const GLOBAL_CATALOG_REQUEST_FAILED = 'GLOBAL_CATALOG_REQUEST_FAILED';

export const GLOBAL_CATALOG_CURRENT_ACTION = 'GLOBAL_CATALOG_CURRENT_ACTION';
export const GLOBAL_CATALOG_RESET_ACTION = 'GLOBAL_CATALOG_RESET_ACTION';